import React from "react";
import { useParams } from "react-router-dom";

export const NameScammed = ({ user }) => {
  let { lang } = useParams();

  const getDisplayName = () => {
    if (!user) return null;
    const { first_name, last_name, user_name } = user;
    return first_name && last_name ? `${first_name} ${last_name}` : user_name;
  };

  return user && <a className="hover:bg-gray-400" href={`/${lang}/search/${user.id}`}>{getDisplayName()}</a>;
};
